/**
 * Application Configuration
 * 
 * This file is auto-generated based on environment variables.
 * Environment: amazonstaging
 * Do not edit this file directly.
 */

const config = {
  // Environment
  nodeEnv: 'amazonstaging',
  
  // API Configuration
  apiBaseUrl: 'https://api-dev.campaignstudio.tv',
  axiosOrigin: 'https://dev.campaignstudio.tv',
  
  // Socket.IO Configuration
  socketIoBaseUrl: 'https://api-dev.campaignstudio.tv',
  
  // Storage Configuration
  s3BaseUrl: 'https://icast-dev-us-east-1.s3.us-east-1.amazonaws.com',
  cloudfrontBaseUrl: 'https://d1w1e72zct24zm.cloudfront.net',
  
  // Feature Flags
  features: {
    enableAnalytics: true,
    enableNotifications: true,
  },
  
  // Other Configuration
  defaultTimezone: 'UTC',
  defaultLanguage: 'en',
  itemsPerPage: 10,
};

export default config;
